module.exports = __webpack_public_path__ + "img/vps10.72e4ef7.png";